import { useFormikContext } from 'formik'
import { Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { TextInputWithHelper } from 'src/components'
import { useStyles } from './style'

import { ICreateRatingSettingsDto } from 'src/types/rating-settings.type'

interface IProps {
  isEditing?: boolean
}

export const RatingSettingsForm = ({ isEditing }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty } =
    useFormikContext<ICreateRatingSettingsDto>()
  const classes = useStyles()

  return (
    <div className={`${classes.formWrapper} ${isEditing ? '' : classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          {isEditing ? (
            <HelperWrapper t="rating-settings-form-edit" ns={ETranslationNs.Common} />
          ) : (
            <HelperWrapper t="rating-settings-form-create" ns={ETranslationNs.Common} />
          )}
        </Typography>
        <div className={classes.inputsWrapper}>
          <TextInputWithHelper
            inputName="name"
            handleChange={handleChange}
            value={values.name}
            error={errors.name ? t(errors.name + '.v') : ''}
            inputPlaceholder={t('rating-settings-name-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'rating-settings-name-input'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
          />
          <TextInputWithHelper
            inputName="min_points"
            handleChange={handleChange}
            value={values.min_points?.toString()}
            error={errors.min_points ? t(errors.min_points + '.v') : ''}
            inputPlaceholder={t('rating-settings-points-placeholder.v')}
            inputUpperLabel={
              <HelperWrapper
                t={'rating-settings-points-input'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
          />
          <TextInputWithHelper
            inputName="rank_color"
            handleChange={handleChange}
            value={values.rank_color}
            inputPlaceholder={t('rating-settings-color-placeholder.v').toLowerCase()}
            inputUpperLabel={
              <HelperWrapper
                t={'rating-settings-color-input'}
                ns={ETranslationNs.Common}
                isInputLable
              />
            }
          />
        </div>
      </div>

      <Button
        variant="contained"
        disabled={isSubmitting || !dirty || !!Object.keys(errors).length}
        type="submit"
      >
        {isEditing ? (
          <HelperWrapper t="update-button-text" />
        ) : (
          <HelperWrapper t="create-button-text" />
        )}
      </Button>
    </div>
  )
}
